import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { BehaviorSubject, Observable } from 'rxjs';


interface IDisabledBtn {
  type: string;
  disabled: boolean;
};
@Injectable()
export class BtnsForGridService extends ParentService {

  private clearFilterGrid = new BehaviorSubject<string>(undefined);
  clearFilterGrid$ = this.clearFilterGrid.asObservable();

  private disabledBtn = new BehaviorSubject<IDisabledBtn>(undefined);
  disabledBtn$ = this.disabledBtn.asObservable();

  private saveLayout = new BehaviorSubject<any>(undefined);
  saveLayout$ = this.saveLayout.asObservable();

  constructor(private http: Http) {
    super();
  }

  clearGridFilter(type: string): void {
    this.clearFilterGrid.next(type);
  }

  btnDisabled(disbaled: IDisabledBtn): void {
    this.disabledBtn.next(disbaled);
  }

  saveLayoutGrid(data): void {
    this.saveLayout.next(data);
  }

  postSaveLayout(data) {
    return this.http.post(constant.URL_SAVE_LAYOUT, data, this.headerPost())
      .map((res: any) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/btns-for-grid/btns-for-grid.service.ts